document.addEventListener('turbolinks:load', function () {
  $('.contents_list_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.contents_list_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.contents_list_slidedown_btn').fadeIn(0));
  });

  $('.contents_list_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.contents_list_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.contents_list_slideup_btn').fadeIn(0));
  });

  
  // -----------------------------------------------------------------------------
  // コンテンツ一覧
  // -----------------------------------------------------------------------------
  // #################################################################
  // コンテンツの新規作成
  // #################################################################
  $('#contents_list_create').on('click', function () {
    const name = $('.contents_list_input').val();

    if (!name) {
      alert('コンテンツ名を入力して下さい。');
      return;
    }

    $.ajax({
      url: '/contents_list/create',
      type: 'POST',
      data: {
        name: name,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.href = `/content/index?contents_id=${data.content.id}`;
      }
    });
  });

  // #################################################################
  // コンテンツ検索
  // #################################################################
  $('#contents_list_search').on('keypress', function (e) {
    let p = $(this).val();
    if (!p) {
      return;
    }

    if (e.which == 13) {
      e.preventDefault();
    
      $('.contents_record').remove();
      let p = $(this).val();

      $.ajax({
        url: 'get_contents_list',
        type: 'POST',
        data: {
          p: p,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == '0') {
          $.each(data.contents, function (index, content) {
            let mode = '';
            if (content.is_mode == 0) {
              mode = 'ポップアップ';
            } else if (content.is_mode == 1) {
              mode = '差し込み配信';
            } else if (content.is_mode == 2) {
              mode = '離脱防止';
            }

            let display_type = '';
            if (content.display_type == 0) {
              display_type = '画像';
            } else if (content.display_type == 1) {
              display_type = 'HTML';
            }

            let preview_btn = '';
            if ((content.display_type == 0 && content.img_url) || (content.display_type == 1 && content.html)) {
              preview_btn = `
                  <div class="contents_preview_btn btn text-14px w-150px my-0 py-13px pl-12px pr-23px cursor-pointer text-center text-white rounded-md bg-cx_base-800 hover:bg-cx_base-500 dark:bg-dark_base dark:hover:bg-dark_base-hover dark:text-gray-500"
                      data-is_mode="${content.is_mode}"
                      data-display_type="${content.display_type}"
                      data-img_url="${content.img_url}"
                      data-html='${content.html}'
                      data-delete_btn_position="${content.delete_btn_position}"
                      data-img_width="${content.img_width}"
                      data-img_height="${content.img_height}">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span>プレビュー</span>
                </div>`;
            }

            $('.contents_list_table').append(
              `<tr class="contents_record h-40px">
                <td class="px-3 py-0 font-normal text-right border-none">${index + 1}:</td>
                <td class="px-3 py-2 border-none box-border max-w-250px ">
                  <a href="/content/index?contents_id=${content.id}">
                    <div class="p-4 rounded-lg hover:bg-light-hover cursor-pointer">${content.name}</div>
                  </a>
                </td>
                <td class="px-3 py-0 border-none text-center">${mode}</td>
                <td class="px-3 py-0 border-none text-center">${display_type}</td>
                <td class="px-3 py-0 border-none text-center">${preview_btn}</td>
                <td class="px-3 py-0 border-none box-border text-center">
                  <div class="content_copy_btn btn text-14px w-150px my-0 p-3 cursor-pointer text-center text-white rounded-md bg-gray-400 hover:bg-gray-500 dark:bg-dark_base dark:hover:bg-dark_base-hover dark:text-gray-500" data-cantent_id="${content.id}">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                    </svg>
                    <span>コピー作成</span>
                  </div>
                </td>
                <td class="px-3 py-0 border-none text-center">
                  <a href="/content_report/index?content_id=<%= c.id %>">
                    <div class="btn text-14px w-150px my-0 p-3 cursor-pointer text-center text-white rounded-md bg-cx_jump-800 hover:bg-cx_jump-500 dark:bg-dark_base dark:hover:bg-dark_base-hover dark:text-gray-500">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                      </svg>
                      <span>レポートへ</span>
                    </div>
                  </a>
                </td>
              </tr>`
            );
          });
        }
      });
    }
  });

  // #################################################################
  // プレビュー表示
  // #################################################################
  $(".contents_preview_btn").on("click", function () {
    let is_mode = $(this).data("is_mode");
    let display_type = $(this).data("display_type");
    let img_url = $(this).data("img_url");
    let html = $(this).data("html");
    let delete_btn_position = $(this).data("delete_btn_position");
    let img_width = $(this).data("img_width");
    let img_height = $(this).data("img_height");

    // $('.contents_preview_btn').css('pointer-events', 'none');
    $(".contents_list_html_preview_wrapper").remove();

    let common_styles = "position:absolute; display:flex; justify-content: center;align-items: center;background-color:#ededed;padding:0;border-radius:9999px;cursor:pointer;user-select:none;height:30px;width:30px;";

    let unique_styles;
    let delete_btn_style;

    switch(delete_btn_position) {
      case 0:
        unique_styles = "right:2px; top:-32px; ";
        break;
      case 1:
        unique_styles = "right:-30px; top:-30px; ";
        break;
      case 2:
        unique_styles = "right:-32px; top:0px; ";
        break;
      case 3:
        unique_styles = "right:2px; top:2px; ";
        break;
      case 4:
        unique_styles = "left:2px; top:-32px; ";
        break;
      case 5:
        unique_styles = "left:-30px; top:-30px; ";
        break;
      case 6:
        unique_styles = "left:-32px; top:0px; ";
        break;
      case 7:
        unique_styles = "left:2px; top:2px; ";
        break;
      default:
        unique_styles = "right:2px; top:-32px; ";
    }

    delete_btn_style = common_styles + unique_styles;

    let el;

    if (display_type == "0") {
      el = `<img src="${img_url}" style="width:${img_width};height:${img_height};">`;
    } else if (display_type == "1"){
      el = html;
    }

    let append_html = `<div class="contents_list_html_preview_wrapper fixed bottom-5 right-[50px]">
                        <button class="contents_list_html_delete_btn" style="${delete_btn_style}">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
                        </button>
                        <div class="contents_list_html_preview">
                          ${el}
                        </div>
                      </div>`;

    $("body").append(append_html);

    $(".contents_list_html_delete_btn").on("click", function() {
      $(this).parent().remove();
      // $('.contents_preview_btn').css('pointer-events', 'auto');
    });
  });

  // #################################################################
  // コンテンツのコピーの作成
  // #################################################################
  $(document).on('click', '.content_copy_btn', function () {
    const cantent_id = $(this).data("cantent_id");

    console.log(2222);

    $.ajax({
      url: '/contents_list/create_copy',
      type: 'POST',
      data: {
        cantent_id: cantent_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

});